@use 'styles/functions/rem' as *;

.field {
    display: flex;
    flex-direction: column;
    gap: rem(2px);
    grid-column: span 3;

    &.fullWidth {
        grid-column: 1 / -1;
    }

    &.thirdWidth {
        grid-column: span 2;
    }
}

.infoGrid {
    display: grid;
    gap: var(--info-grid-gap);
    grid-template-columns: repeat(6, 1fr);
    padding-top: var(--info-grid-padding-top);
    width: 100%;
}

.label {
    color: var(--info-grid-label-color);
    font-size: var(--info-grid-label-font-size);
    font-weight: var(--info-grid-label-font-weight);
    letter-spacing: var(--info-grid-label-letter-spacing);
    text-transform: uppercase;
}

.required {
    color: var(--info-grid-required-color);
    margin-left: var(--info-grid-required-margin-left);
}
